var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container fullscreen"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-xl-5 col-lg-6 col-md-7"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }